import React, { useEffect, useRef, useState } from 'react';

const ProblemSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const problems = [
    {
      number: "01",
      title: "Data Privacy Is Based on Trust, Not Architecture",
      points: [
        "Privacy relies on policies, not technical safeguards",
        "Data leakage and session logging",
        "Model training on sensitive inputs",
        "Loss of control once data leaves your device"
      ]
    },
    {
      number: "02",
      title: "Local Device Exposure",
      points: [
        "AI accessed via browsers creates direct exposure",
        "Browser fingerprinting and cookie leakage",
        "Risks from extensions and injected scripts",
        "Your machine becomes the attack surface"
      ]
    },
    {
      number: "03",
      title: "Compromised Package Dependencies",
      points: [
        "AI generates code requiring dependencies",
        "Single compromised package executes malicious code",
        "Wallet drainage, key theft, credential exposure",
        "Even experts can't audit every package"
      ]
    }
  ];

  return (
    <section className="problems-section" id="problem" data-testid="problems-section" ref={sectionRef}>
      <div className="problems-content">
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <span className="section-number">01</span>
          <p className="section-label-new">The Problem</p>
          <h2 className="section-title-new">AI tools are unavoidable.<br/>The security model hasn't evolved.</h2>
        </div>
        
        <div className="problems-cards">
          {problems.map((problem, index) => (
            <div 
              key={index} 
              className={`problem-card ${isVisible ? 'animate' : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
              data-testid={`problem-card-${index}`}
            >
              <span className="problem-card-number">{problem.number}</span>
              <h3 className="problem-card-title">{problem.title}</h3>
              <ul className="problem-card-list">
                {problem.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
